import { getPrice } from '@fourthwall/utils';
export const formatMoney = (value, currency) => value ? getPrice(value, { currency }) : '';
